var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoldersArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 32,
    viewBox: "0 0 6 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 1a.5.5 0 00-1 0h1zM3 32l2.887-5H.113L3 32zM2.5 1v26.5h1V1h-1z",
    fill: "#1D7777"
  })));
}
export default SvgFoldersArrow;